export const GET_LAND_OWNER= '/get_land_owner';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';
export const UPDATE_LAND_OWNER= '/update_land_owner';
export const CREATE_LAND_OWNER= '/create_land_owner';
export const REMOVE_LAND_OWNER= '/remove_land_owner';

export const CREATE_CO_OWNER = '/create_co_owner';
export const UPDATE_CO_OWNER = '/update_co_owner';
export const REMOVE_CO_OWNER = '/remove_co_owner';

export const GET_OWNER_PROPERTIES = '/get_owner_properties'
 
export const FORM_DATA = {
  name: '',
  address: '',
  telephone_no: '',
  tin: '',
  region_code: '',
  municipality_code: '',
  province_code: '',
  barangay_code: '',
  street: '',
};